import { render, staticRenderFns } from "./WareHouseSection.vue?vue&type=template&id=1dbc970d&"
import script from "./WareHouseSection.vue?vue&type=script&lang=js&"
export * from "./WareHouseSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports